/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import cn from "classnames";

import Image from "../Image/Image";

import s from "./Avatar.module.css";

import { useEnvs } from "state/EnvironmentsContext/EnvContext";

interface IAvatar {
  src?: string;
  alt?: string;
  size?: "xxs" | "xs" | "sm" | "md" | "lg" | "xl" | "xxl" | "full";
  defaultColor?: string;
  hasBorder?: boolean;
  className?: string;
  fit?: "cover" | "contain" | "fill";
  borderWidth?: boolean;
  placeholderSize?: "sm" | "md" | "lg";
}

const Avatar = ({
  src,
  placeholderSize,
  alt,
  size = "sm",
  hasBorder,
  className,
  fit = "cover",
  defaultColor,
  ...props
}: IAvatar) => {
  const rootClass = cn(
    s.root,
    s.circle,
    hasBorder && s.hasBorder,
    size && s[size],
    className,
  );

  const { placeholder, placeholder_small, placeholder_large } = useEnvs(
    (s) => s,
  );

  let fitClass;
  if (fit?.includes("cover")) {
    fitClass = "object-cover";
  }

  if (fit?.includes("contain")) {
    fitClass = "object-contain";
  }

  if (fit?.includes("fill")) {
    fitClass = "object-fill";
  }

  if (!src && defaultColor) {
    return (
      <div
        className={rootClass}
        style={{
          backgroundColor: defaultColor,
        }}
        {...props}
        test-id="Ob5uhAMZ"
      />
    );
  }

  let DEFAULT_PLACEHOLDER = placeholder;

  switch (placeholderSize) {
    case "sm":
      DEFAULT_PLACEHOLDER = placeholder_small;
      break;
    case "md":
      DEFAULT_PLACEHOLDER = placeholder;
      break;
    case "lg":
      DEFAULT_PLACEHOLDER = placeholder_large;
      break;
  }

  return (
    <div className={rootClass} {...props} test-id="ldCWi719">
      <Image
        src={src || DEFAULT_PLACEHOLDER}
        alt={alt || ""}
        className={cn(s.img, fitClass)}
        test-id="_mZd13U5"
      />
    </div>
  );
};

export default Avatar;
